import ExamSelector from './src/main';

/* istanbul ignore next */
ExamSelector.install = function(Vue) {
  Vue.component(ExamSelector.name, ExamSelector);
};

export default ExamSelector;
